import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Ana Sayfa', icon: 'ri-home-4-line', activeIcon: 'ri-home-4-fill' },
    { path: '/hakkinda', label: 'Hakkında', icon: 'ri-user-line', activeIcon: 'ri-user-fill' },
    { path: '/galeri', label: 'Galeri', icon: 'ri-image-line', activeIcon: 'ri-image-fill' },
    { path: '/blog', label: 'Blog', icon: 'ri-article-line', activeIcon: 'ri-article-fill' },
    { path: '/iletisim', label: 'İletişim', icon: 'ri-mail-line', activeIcon: 'ri-mail-fill' },
  ];

  return (
    <>
      {/* Desktop & Mobile Top Header */}
      <motion.header
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6 }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <span className={`font-serif text-xl font-bold ${isScrolled ? 'text-navy' : 'text-white'}`}>
                Fatih Sinan YILMAZ
              </span>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`font-sans text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                    location.pathname === link.path
                      ? isScrolled
                        ? 'text-gold'
                        : 'text-white'
                      : isScrolled
                      ? 'text-navy hover:text-gold'
                      : 'text-white/90 hover:text-white'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      </motion.header>

      {/* Mobile Bottom Navigation */}
      <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-100">
        <div className="flex items-stretch">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className="flex-1 flex flex-col items-center justify-center py-2 cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i
                    className={`${isActive ? link.activeIcon : link.icon} text-xl ${
                      isActive ? 'text-gold' : 'text-gray-400'
                    }`}
                  ></i>
                </div>
                <span
                  className={`text-[10px] mt-0.5 font-sans font-medium whitespace-nowrap ${
                    isActive ? 'text-gold' : 'text-gray-400'
                  }`}
                >
                  {link.label}
                </span>
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
};

export default Header;
